// AppModel.js
import { atom } from 'jotai';
import { DefaultRule } from './AppConst';

// 매매 규칙. 사용자가 설정한 규칙을 저장하는 atom
/*
const simulationRuleAtom = atom({
    key: 'simulationRule',
    // get only default value of DefaultRule
    default: Object.fromEntries(
        Object.entries(DefaultRule).map(([key, value]) => [key, value.default])
    )
});
export { simulationRuleAtom };

// 주가데이터 records
const stockDataAtom = atom({
    key: 'stockData',
    default: []
});
export { stockDataAtom };
*/

// Jotai 사용해서 다시 선언.
export const simulationRuleAtom = atom({
    minimalTradeTimes: DefaultRule.minimalTradeTimes.default,
    buyInterval: DefaultRule.buyInterval.default,
    buyAmount: DefaultRule.buyAmount.default,
    bullIntervalFactor: DefaultRule.bullIntervalFactor.default,
    bearIntervalFactor: DefaultRule.bearIntervalFactor.default,
    avgDownFactorMax: DefaultRule.avgDownFactorMax.default,
    acceptableChange: DefaultRule.acceptableChange.default,
    partialSellOnProfit: DefaultRule.partialSellOnProfit.default,
    partialSellThreshold: DefaultRule.partialSellThreshold.default,
    exitOnProfit: DefaultRule.exitOnProfit.default,
    exitOnProfitDrop: DefaultRule.exitOnProfitDrop.default,
    suddenDropBuyThreshold: DefaultRule.suddenDropBuyThreshold.default,
    suddenDropBuyFactor: DefaultRule.suddenDropBuyFactor.default,
    rollingHighPeriod: DefaultRule.rollingHighPeriod.default,
});

export const stockDataAtom = atom([]); // array of stock data records

export const ruleToApplyAtom = atom(null); // rule to apply for simulation, null means no rule selected
// ruleToApplyAtom should be a copy of simulationRuleAtom value
// 거기에 시작날짜와 종료날짜를 추가한다.

export const stockTickersAtom = atom([]); // array of stock tickers
export const etfTickersAtom = atom([]); // array of ETF tickers